module.exports = __webpack_public_path__ + "static/media/Lover.7ecab439.svg";